import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { Calculator, useSession } from '@ratehub/base-ui';
import { PURPOSES, SUBMISSION_SOURCES } from '@ratehub/documents/mtg-journey-document/stable';
import { findOrCreateDocument } from '@ratehub/mtg-common';


function MortgageCalculator({
    purpose = PURPOSES.PURCHASE_STILL_LOOKING,
    isSaveEnabled = false,
    ...otherProps
}) {
    const { locale } = useIntl();
    const sessionStore = useSession();

    // Document integration is fully fledged out and causes problems with the current setup
    // See this issue for more details: https://ratehub.slack.com/archives/CHW3MPMTQ/p1727788003961119
    const fetchDocument = useCallback(
        () => findOrCreateDocument({
            sessionStore,
            locale,
            purpose,
            source: SUBMISSION_SOURCES.CALCULATOR,
            enableSavingData: true,
        }),
        [ purpose, isSaveEnabled, locale, sessionStore ]
    );

    return (
        <Calculator
            fetchDocument={isSaveEnabled ? fetchDocument : null}
            {...otherProps}
        />
    );
}

MortgageCalculator.propTypes = {
    purpose: PropTypes.string,
    isSaveEnabled: PropTypes.bool,
};


export default MortgageCalculator;
